<template>
  <eva-main @back="goBack">
    <template slot="nav">
      <div class="evaNav">
        <p>培训机构调查</p>
      </div>
    </template>
    <template slot="main">
      <div class="evaMain">
        <template v-if="showInfo">
          <div class="userInfo">
            <div class="left">
              <img :src="!userInfo.profile_picture ? userImg : userInfo.profile_picture"
                   @error="imgError"
                   alt="">
            </div>
            <div class="right">
              <div class="line">
                <p class="username">
                  <span @click="lookOver(userInfo.org_id)">{{userInfo.name}}</span>
                </p>
                <p>注册时间：{{userInfo.create_time.time | time}}</p>
                <p>状态：{{ userInfo.status | userText }}</p>
              </div>
              <div class="line">
                <p>管理员姓名：{{userInfo.user_name}}</p>
                <p>培训班数量：{{userInfo.class_train_num}}个</p>
                <p>学员数量：{{userInfo.student_num}}个</p>
              </div>
              <div class="line">
                <p>城市：{{ userInfo.provice_name }}{{ userInfo.city_name }}</p>
                <p>电话：{{userInfo.tel_number||"--"}}</p>
              </div>
              <div class="line">
                <p>详细地址：{{userInfo.address||"--"}}</p>
              </div>
            </div>
          </div>
        </template>
        <yioks-loading v-show="isLoading"></yioks-loading>
        <template v-if="!isLoading">
        <div class="scrollArea">
          <vue-scroll :ops="ops">
            <div class="wrap">
              <div class="item">
                <div  class="search">
                  <el-date-picker
                          v-model="selectVal.start_date"
                          type="date"
                          :picker-options="startTime"
                          value-format="timestamp"
                          placeholder="评价开始日期">
                  </el-date-picker>
                  <el-date-picker
                          style="margin-left: 20px"
                          v-model="selectVal.end_date"
                          value-format="timestamp"
                          type="date"
                          :picker-options="endTime"
                          placeholder="评价结束日期">
                  </el-date-picker>
                  <span class="searchBtn" @click="search">搜索</span>
                </div>
                <div class="title">
                  <v-icon name="user-friends"
                          scale="1.7"></v-icon>
                  <p><strong>学员对机构的总体调查统计</strong></p>
                </div>
                <template v-if="stuStatus">
                  <eva-charts :star="stuStar"
                    :eat="eat_sleep_score_list"
                    :practice_room="practice_room_score_list"
                    :practice_team="practice_team_score_list"
                    :theory_room="theory_room_score_list"
                    :train_clothing="train_clothing_socre_list"
                    :showScore="showScore"
                    :showPracticeTeam="true"
                              :question="stuQuestion"></eva-charts>
                  <div class="splitLine"></div>
                  <!--<eva-opinions :opinions="stuOpinions"></eva-opinions>-->
                  <eva-opinions :ids="opinionId"></eva-opinions>
                </template>
                <template v-if="stuEmpty">
                  <yioks-empty :h="'300px'"></yioks-empty>
                </template>
              </div>
              <div class="item">
                <div class="title">
                  <v-icon name="sitemap"
                          scale="1.7"></v-icon>
                  <p><strong>讲师对机构的总体调查统计</strong></p>
                </div>
                <template v-if="teaStatus">
                  <eva-charts :star="teaStar"
                              :question="teaQuestion"></eva-charts>
                  <div class="splitLine"></div>
                  <!--<eva-opinions :opinions="orgOpinions"></eva-opinions>-->
                  <eva-opinions :ids="opinionIdElse"></eva-opinions>
                </template>
                <template v-if="teaEmpty">
                  <yioks-empty :h="'300px'"></yioks-empty>
                </template>
              </div>
            </div>
          </vue-scroll>
        </div>
        </template>
      </div>
    </template>
  </eva-main>
</template>

<script>
  import userImg from "@/assets/images/person.png";
  import ops from "@/assets/js/vuescrollOption";
  import "vue-awesome/icons/user-friends";
  import "vue-awesome/icons/sitemap";
  import {orgDetailInfo, evaTeaOrg} from "@/api/system_manager/api";
  import {userStatus} from "@/assets/js/status";
  import {area_name} from "@/assets/js/region";
  import fiveMixins from '@/minix/fiveMixins';

  export default {
    name: "eva-organization-detail",
    mixins: [fiveMixins],
    data() {
      const id = this.$route.query.id.toString();
      const year=new Date().getFullYear();
      const tmp=new Date(`${year}-1-1`).getTime();
      return {
        userImg,
        ops: ops(),
        id,
        userInfo: {},
        selectVal:{
          end_date:new Date().getTime(),
          start_date: tmp
        },
        showInfo: false,
        stuStatus: false,
        stuEmpty: false,
        stuStar: [],
        stuQuestion: {
          yes: [],
          no: [],
          opt: [],
        },
        startTime: {
          disabledDate: time => {
            if (this.selectVal.end_date) {
              return (
                      new Date(time).getTime()  > new Date(this.selectVal.end_date).getTime() - 86400000
              );
            }
          }
        },
        endTime: {
          disabledDate: time => {
            if (this.selectVal.start_date)
              return (
                      new Date(time).getTime() < new Date(this.selectVal.start_date).getTime()
              );
          }
        },
        opinionId: {
          obj_id: id,
          tpl_id: "2",
          start_date:'',
          end_date:'',
        },
        teaStatus: false,
        teaEmpty: false,
        teaStar: [],
        showScore:false,
        theory_room_score_list: [],
        practice_room_score_list: [],
        eat_sleep_score_list: [],
        practice_team_score_list: [],
        train_clothing_socre_list: [],
        teaQuestion: {
          yes: [],
          no: [],
          opt: [],
        },
        opinionIdElse: {
          obj_id: id,
          tpl_id: "3",
          start_date:'',
          end_date:'',
        },
        isLoading: true
      };
    },
    components: {
      "eva-main": () => import("@/components/LayOut/Common/up-down"),
      "eva-charts": () => import("@/components/Evaluation/Echarts"),
      "eva-opinions": () => import("@/components/Evaluation/other-opinions"),
      "v-icon": () => import("vue-awesome/components/Icon"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
    },
    filters: {
      userText(status) {
        return userStatus(status);
      },
    },
    created() {
      this.setTpl();
      this.setDate()
      this.setData()
      this.requestInfo();
      this.requestEvaData();
    },
    methods: {
      setTpl() {
         if(this.isFive) {
           this.$set(this.opinionId, 'tpl_id', '201');
           this.$set(this.opinionIdElse, 'tpl_id', '202');
         }
      },
      goBack() {
        this.$router.go(-1);
      },
      setDate(){
        this.$set(this.opinionId,'start_date',this.selectVal.start_date);
        this.$set(this.opinionId,'end_date',this.selectVal.end_date);
        this.$set(this.opinionIdElse,'start_date',this.selectVal.start_date);
        this.$set(this.opinionIdElse,'end_date',this.selectVal.end_date);
      },
      search(){
        this.setDate()
        // this.$set(this.opinionId,'start_date',this.selectVal.start_date)
        // this.$set(this.opinionId,'end_date',this.selectVal.end_date)
        this.changeQuery()
        this.requestEvaData()
      },
      setData() {
        const { start_date,end_date } = this.$route.query;
        if ('start_date' in this.$route.query){
          this.$set(this.selectVal, "start_date", start_date)
          this.$set(this.opinionId,'start_date',this.selectVal.start_date);
          this.$set(this.opinionIdElse,'start_date',this.selectVal.start_date);
        }
        if ('end_date' in this.$route.query){
          this.$set(this.selectVal, "end_date", end_date)
          this.$set(this.opinionIdElse,'end_date',this.selectVal.end_date);
          this.$set(this.opinionId,'end_date',this.selectVal.end_date);
        }
      },
      changeQuery(){
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            start_date: this.selectVal.start_date,
            end_date: this.selectVal.end_date,
          }
        });
      },
      requestInfo() {
        orgDetailInfo({"org_id": this.id})
          .then((res) => {
            // console.log(res);
            if (Number(res.data.status) == 0) {
              const {organization_info} = res.data.result;
              this.userInfo = organization_info;
              this.showInfo = true;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      },
      requestEvaData() {
        this.isLoading = true;
        evaTeaOrg({"obj_type": "organization", "obj_id": this.id,start_date:this.selectVal.start_date,end_date:this.selectVal.end_date})
          .then((res) => {
            // console.log(res);
            if (Number(res.data.status) == 0) {
              let {one_status, two_status} = res.data.result.survey_status;
              one_status = Boolean(Number(one_status) !== 0);
              two_status = Boolean(Number(two_status) !== 0);
              if(one_status) {
                const {survey_one} = res.data.result;
                this.stuStar = survey_one.survey_one_star;
                this.theory_room_score_list = survey_one.survey_more_theory_room_score;
                this.practice_room_score_list = survey_one.survey_more_practice_room_score;
                this.eat_sleep_score_list = survey_one.survey_more_eat_sleep_score;
                this.practice_team_score_list = survey_one.survey_more_practice_team_score;
                this.train_clothing_socre_list = survey_one.survey_more_train_clothing_socre;
                this.$set(this.stuQuestion, "yes", survey_one.survey_one_question_yes);
                this.$set(this.stuQuestion, "no", survey_one.survey_one_question_no);
                this.$set(this.stuQuestion, "opt", survey_one.survey_one_question_option);
                this.theory_room_score_list.map(item=>{
                  if(item>0){
                    this.showScore = true;
                  }
                });
              }
              if(two_status) {
                const {survey_two} = res.data.result;
                this.teaStar = survey_two.survey_two_star;
                this.$set(this.teaQuestion, "yes", survey_two.survey_two_question_yes);
                this.$set(this.teaQuestion, "no", survey_two.survey_two_question_no);
                this.$set(this.teaQuestion, "opt", survey_two.survey_two_question_option);
              }
              this.stuStatus = one_status;
              this.teaStatus = two_status;
              this.stuEmpty = !this.stuStatus;
              this.teaEmpty = !this.teaStatus;
              this.isLoading = false;
            }
          })
          .catch((err) => {
            this.isLoading = false;
            console.error(err);
          });
      },
      imgError() {
        this.$set(this.userInfo, 'profile_picture', this.userImg);
      },
      lookOver(id) {
        this.$router.push({path: 'od', query: {id: id}});
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  @import "~@/assets/css/mixin";
  .evaNav {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .evaMain {
    width: 100%;
    height: 100%;
    background-color: $block_bg_color_base;
    .userInfo {
      height: 131px;
      margin: 0 30px;
      padding: 15px 0;
      display: flex;
      border-bottom: 1px solid $color_white;
      .left {
        height: 100%;
        flex: 0 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
      }
      .right {
        height: 100%;
        padding: 0 0 0 30px;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: $font_size_medium;
        line-height: $font_size_medium;
        .line {
          display: flex;
          align-items: flex-end;
          p {
            margin: 0 30px 0 0;
          }
          .username {
            font-size: $font_size_big;
            line-height: $font_size_big;
            span {
              cursor: pointer;
              color: $color_suc;
            }
          }
        }
      }
    }
    .scrollArea {
      height: calc(100% - 131px);
      padding: 10px 0;
      .wrap {
        width: 100%;
        padding: 0 30px;
        .item {
          width: 100%;
          /*padding: 0 0 0 20px;*/
          margin: 0 0 30px 0;
          box-sizing: border-box;
          .search{
            display flex
            justify-content flex-end
            align-items center
            padding-bottom 15px
            border-bottom 1px solid $color_white
            .searchBtn{
              margin-left: 20px
              display inline-block
              width: 90px;
              height 40px
              text-align center
              line-height 40px
              font-size: 20px;
              background-color: #4cd964;
              cursor: pointer;
              user-select: none;
            }
          }

          .title {
            padding: 10px 0;
            margin: 0 0 10px 0;
            display: flex;
            align-items: center;
            font-size: 20px;
            border-bottom: 1px solid $color_white;
            p {
              margin: 0 0 0 10px;
            }
          }
          .splitLine {
            height: 30px;
          }
        }
      }
    }
    .loading-wrap-root{
      top: 200px;
    }
  }
</style>
